"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M30.25 25.109a2.891 2.891 0 1 1-2.891-2.891 2.891 2.891 0 0 1 2.891 2.891z" }),
  React.createElement("path", { d: "M37.808 25.78a1 1 0 0 1-1.744-.4L36 25.124v9.784c-.3-.266-2.677-2.346-4.773-2.346-2.24 0-3.829 2.947-7.227 2.947s-6.283-6.233-9.82-6.233c-3.011 0-7.856 5.271-8.18 5.627V18h28.25l-.265-1.079L28.771 14H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h34a2 2 0 0 0 2-2V23.108zm5.134-10.4a3.5 3.5 0 0 0-2.925 1.786l-2.1 3.745-.155-4.29a3.5 3.5 0 0 0-1.785-2.921l-3.745-2.1 4.29-.155a3.5 3.5 0 0 0 2.925-1.786l2.1-3.745.153 4.286a3.5 3.5 0 0 0 1.786 2.925l3.745 2.1zM24.028 5.322L27.46 5.2a2.8 2.8 0 0 0 2.34-1.431l1.678-3L31.6 4.2a2.8 2.8 0 0 0 1.429 2.34l3 1.678-3.429.13a2.8 2.8 0 0 0-2.34 1.429l-1.678 3-.124-3.432A2.8 2.8 0 0 0 27.024 7z" })
);

